import {
    MenuItemProps,
} from "@bsm/component";
import { useLeftSideBarMenuGeneral } from "./useLeftSideBarMenuGeneral";
import { useLeftSideBarMenuParameters } from "./useLeftSideBarMenuParameters";

export const useLeftSideBarMenu = (): Array<MenuItemProps> => {

    const generalMenu = useLeftSideBarMenuGeneral()
    const parametersMenu = useLeftSideBarMenuParameters()

    return [
        generalMenu,
        parametersMenu
    ];
};

